module.exports = __webpack_public_path__ + "static/media/t4c-logo-white.0ce95406.png";